<template>
  <div style="text-align: left;">
    <select v-model="currentScene">
      <option v-for="(item, index) in sceneList" :value="item.id" :key="index">{{item.name}}</option>
    </select>
    <hr>
    <div class="row my-5" style="margin: 0">
      <div class="col-5">
        <div class="wrapper">
          <div class="scrollbar" id="style-3">
            <div class="force-overflow">
              <ul v-for="(item, index) in unusedData" :key='index' class='p-0 m-0'>
                <li>
                  <span @click="userSelected(item)" :class="{'active': selectedData.some((el)=> {return el === item} )}">{{item}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <h5>{{$t('select them_to_column')}}</h5>
      </div>
      <div class="col-2 m-auto">
        <button type="button" @click="addUsedData" class="btn btn-primary change-btn">> ></button>
        <button type="button" @click="removeUsedData" class="btn btn-primary change-btn">< <</button>
      </div>
      <div class="col-5">
        <div class="wrapper">
          <div class="scrollbar" id="style-3">
            <div class="force-overflow">
              <ul v-for="(item, index) in usedData" :key='index' class='p-0 m-0'>
                <li>
                  <span @click="userSelected(item)" :class="{'active': selectedData.some((el)=> {return el === item} )}" >{{index + 1}}. {{item}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex" style="float:right">
      <button @click="clearForm" type="button" class="btn btn-primary mx-3 px-">{{$t('cancel')}}</button>
      <button :disabled="usedLength < 7" @click="addVocabularies" type="button" class="btn btn-primary mx-3 px-4">{{$t('save')}}</button>
    </div>
  </div>
</template>

<script>
import swal from 'bootstrap-sweetalert'
import api from '../../../store/api'
export default {
  name: 'FormAR',
  components: {
  },
  data () {
    return {
      unusedData: [],
      selectedData: [],
      usedData: [],
      isOpen: false,
      sceneList: [],
      currentScene: 0
    }
  },
  computed: {
    usedLength () {
      return this.usedData.length
    }
  },
  watch: {
    currentScene (val) {
      this.getVocabularies()
      this.selectedData = []
      this.usedData = []
    }
  },
  mounted () {
    this.getSceneList()
    this.getVocabularies()
  },
  methods: {
    async getVocabularies () {
      let sceneId = this.currentScene
      const { data } = await api.get(`/VR/Scene/${sceneId}/Vocabularies`)
      let params = {
        sceneId: this.currentScene
      }
      api.get(`/VR/VocabMode/Challenge/Vocabluaries`, {params}).then((res) => {
        this.usedData = res.data.data
        res.data.data.map((el) => {
          let idx = data.data.indexOf(el)
          data.data.splice(idx, 1)
        })
        this.unusedData = data.data
      })
    },
    userSelected (item) {
      let idx = this.selectedData.map((el) => { return el }).indexOf(item)
      idx < 0 ? this.selectedData.push(item) : this.selectedData.splice(idx, 1)
    },
    addUsedData () {
      if (this.usedData.length < 7) {
        if (this.selectedData.length + this.usedData.length <= 7) {
          this.usedData = this.usedData.concat(this.selectedData)
          this.unusedData = this.unusedData.filter((el) => { return this.selectedData.indexOf(el) === -1 })
          this.usedData = this.usedData.filter(function (el, idx, arr) {
            return arr.indexOf(el) === idx
          })
        }
      }
      this.selectedData = []
    },
    removeUsedData () {
      let data = this.unusedData.concat(this.selectedData)
      data.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase())
      })
      this.unusedData = data
      this.usedData = this.usedData.filter((el) => { return this.selectedData.indexOf(el) === -1 })
      this.unusedData = this.unusedData.filter(function (el, idx, arr) {
        return (arr.indexOf(el) === idx)
      })
      this.selectedData = []
    },
    async getSceneList () {
      const { data } = await api.get(`/VR/Scene`)
      this.sceneList = data.data
      this.currentScene = data.data[0].id
    },
    clearForm () {
      this.selectedData = []
      this.getVocabularies()
    },
    async addVocabularies () {
      let params = {
        sceneId: this.currentScene
      }
      const { data } = await api.patch(`/VR/VocabMode/Challenge/Vocabluaries`, this.usedData, {params})
      console.log(data)
      swal(this.$t('saved_successfully') + '!', this.$t('added_vocabulary'), 'success')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
select {
  border: rgba(0,0,0,0.3) 2px solid;
  border-radius: 5px;
  outline: none;
  padding: 2px;
}
.change-btn {
  margin: 10% 20% ;
  width: 60%;
}
.scrollbar {
  height: 300px;
  width: 100%;
  overflow-y: auto;
}
.force-overflow {
  // min-height: 1800px;
}
.wrapper {
  text-align: left;
  border: solid 2px rgba(0,0,0,0.3);
  padding: 5px;
  border-radius: 10px;
  padding: 10px 20px;
}
#style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}
#style-3::-webkit-scrollbar {
  width: 2px;
  background-color: #F5F5F5;
}
#style-3::-webkit-scrollbar-thumb {
  background-color: #000000;
}
li {
  list-style: none;
  display: flex;
  justify-content:space-between;
  span {
    width: 90%;
    line-height: 2rem;
    padding-left: 1rem;
    cursor: pointer;
  }
  img {
    cursor: pointer;
  }
}
.active {
  background-color: #d6d6d6;
}
</style>



// WEBPACK FOOTER //
// VocabularyForm.vue?8384ab82